<template>

    <div>
        <span class="font-size-14">
            <span>{{visit.scheduled_visit_job_status_text}}</span>
            <b v-if="visit.calculated_time"> {{visit.calculated_time}}</b>
            <!-- Auto check-in case -->
        <span>
            <span  class="font-size-14" v-if="visit.auto_check_in">
                ({{ visit.action_time }} {{ visit.estimate_time_to_arrive }}, Auto check-in {{ visit.auto_check_in_time }})
            </span>

            <!-- Auto check-out case -->
            <span  class="font-size-14" v-else-if="visit.auto_check_out">
                ({{ visit.action_time }} & Estimated time of completion {{ visit.estimate_time_to_finish }}, Auto check-out {{ visit.auto_check_out_time }})
            </span>

            <!-- Default case -->
            <span v-else>
                <span  class="font-size-14" v-if="visit.not_attending_fieldworker_username">
                    (
                    <a class="contractor-popover" :class="'contractor-' + visit.id + '-' + service.service_id + '-' + service.clone" href="#"
                       :data-contractor_id="visit.not_attending_fieldworker_id" :data-uid="'contractor-' + visit.not_attending_fieldworker_id">
                        <span class="normal_font">{{ visit.not_attending_fieldworker_username }}</span>
                    </a>
                    )
                </span>

                <span v-if="visit.action_time && visit.show_action_time">
                    ({{ visit.action_time }}
                    <span  class="font-size-14" v-if="visit.show_estimate_time_to_arrive && visit.estimate_time_to_arrive">
                        & ETA of arrival {{ visit.estimate_time_to_arrive }}
                    </span>
                    <span  class="font-size-14" v-if="visit.show_estimate_time_to_finish && visit.estimate_time_to_finish">
                        & Estimated time of completion {{ visit.estimate_time_to_finish }}
                    </span>
                    )
                </span>
            </span>
        </span>
                <a href="javascript:;" onclick=" popupi_alert(``,`This value indicates the appointment status based on the last update made by the assigned fieldworker through the fieldworker app, this value is view only for admin users and can only be updated by the fieldworker `); $(`.modal-footer`).hide(); "><i class="fa fa-info-circle fa-lg"></i></a>

        </span>

    </div>
</template>

<script>


export default {
    name: "fieldworkerTodayProcess",
    props: {

        visit: {
            type: Object,
            required: true
        },
        service: {
            type: Object,
            required: true
        },
        itemId: {},
        index: {
            type: Number,
            default() {
                return 0;
            }
        },
    },
    computed: {
    },
    methods: {
    },
    mounted() {
    }
}
</script>

<style scoped>

</style>
